export default "__VITE_ASSET__DtwOvD1T__"